module.exports = __webpack_public_path__ + "img/估价大背景@2x.e3979af9.png";